var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_has.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_has.js
// module chunks = 168707334958949